import { CheckCheckIcon, CheckIcon } from "./icons";

export type DeliveryStatus = "sending" | "sent" | "delivered" | "read" | "failed";

const labels: Record<DeliveryStatus, string> = {
  sending: "Sending",
  sent: "Sent",
  delivered: "Delivered",
  read: "Read",
  failed: "Not sent",
};

// Ticks change shape as well as colour: one grey tick, two grey ticks, two blue ticks.
export function Ticks({
  status,
  size = 16,
  label,
}: {
  status: DeliveryStatus;
  size?: number;
  label?: string;
}) {
  const text = label ?? labels[status];
  if (status === "failed" || status === "sending") return null;
  if (status === "sent") {
    return <CheckIcon size={size} strokeWidth={2.6} className="text-tick-delivered" label={text} />;
  }
  return (
    <CheckCheckIcon
      size={size}
      strokeWidth={2.6}
      className={status === "read" ? "text-tick-read" : "text-tick-delivered"}
      label={text}
    />
  );
}

export const deliveryLabel = (status: DeliveryStatus) => labels[status];
